import iconTemplate from '~/components/icons/IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Class-Lesson--Streamline-Flex"
    >
        <desc>{'Class Lesson Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="class-lesson--class-lesson-education-teacher">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.81738 0.518483C7.36351 0.5 7.92016 0.5 8.46633 0.5c1.24931 0 2.55347 0 3.66097 0.221208 0.6131 0.122453 1.0687 0.621102 1.1941 1.233592 0.1785 0.8718 0.1785 1.5405 0.1785 2.97591 0 1.43541 0 2.10411 -0.1785 2.97591 -0.1254 0.61249 -0.581 1.11115 -1.1941 1.2336 -0.9324 0.18622 -2.0041 0.21567 -3.06511 0.22032"
                strokeWidth={1}
            />
            <path
                id="Union"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.79521 5.625C2.00442 5.625 0.304426 6.91322 0.518248 8.6912c0.016612 0.13813 0.036442 0.28306 0.059477 0.43721 0.068548 0.45875 0.468575 0.79204 0.932405 0.79204h0.53021l0.38682 2.40155c0.10935 0.6789 0.6953 1.178 1.38293 1.178s1.27358 -0.4991 1.38293 -1.178l0.86135 -4.15056h1.22517c1.99968 0 2.13964 -2.54644 0 -2.54644H3.79521Z"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.77112 3.93747c0.96 0 1.5 -0.54 1.5 -1.5s-0.54 -1.500001 -1.5 -1.500001 -1.5 0.540001 -1.5 1.500001 0.54 1.5 1.5 1.5Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
